import { useState } from "react";

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="header">
      <nav className="navbar navbar-expand-lg navbar-dark bg-primary shadow-sm fixed-top">
        <div className="container">
          {/* Brand/Logo Section */}
          <a className="navbar-brand d-flex align-items-center" href="/">
            <i className="fas fa-orbit fa-lg me-2 text-info"></i>
            <span className="fw-bold">BlueOrbit Technologies</span>
          </a>

          {/* Mobile Toggle Button */}
          <button
            className="navbar-toggler"
            type="button"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            aria-expanded={isMenuOpen}
            aria-label="Toggle navigation"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNav"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          {/* Navigation Links - Collapsible Section */}
          <div className={`collapse navbar-collapse ${isMenuOpen ? 'show' : ''}`} id="navbarNav">
            <ul className="navbar-nav ms-auto mb-2 mb-lg-0 fw-bold ">
              <li className="nav-item">
                <a className="nav-link text-white fw-dark" aria-current="page" href="/" onClick={() => setIsMenuOpen(false)}>
                  <i className="fas fa-home me-1"></i>Home
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link text-white fw-dark" href="/aboutUs" onClick={() => setIsMenuOpen(false)}>
                  <i className="fas fa-info-circle me-1"></i>About
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link text-white fw-dark" href="/ourApps" onClick={() => setIsMenuOpen(false)}>
                  <i className="fas fa-mobile-alt me-1"></i>Our Apps
                </a>
              </li>
              {/* Optional: Add a call-to-action button */}
              <li className="nav-item ms-lg-2 mt-2 mt-lg-0">
                <a 
                  className="btn btn-outline-light btn-sm" 
                  href="/contact"
                  onClick={() => setIsMenuOpen(false)}
                >
                  <i className="fas fa-paper-plane me-1"></i>Contact
                </a>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Header;